/**
 * Fechas en pantalla del módulo ERP — convención CLAUDE.md "Fechas" (Erwin,
 * 2026-09-04): SIEMPRE DD/MM/AAAA hacia el usuario, nunca el ISO crudo.
 * Almacenamiento y APIs siguen en ISO YYYY-MM-DD.
 *
 * Acepta: 'YYYY-MM-DD', ISO con hora, Timestamp de Firestore ({_seconds} /
 * {seconds} / toDate()), Date o epoch ms. Devuelve '—' si no hay valor.
 */

const pad = (n) => String(n).padStart(2, '0');

const toDate = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (value instanceof Date) return value;
  if (typeof value === 'object') {
    if (typeof value.toDate === 'function') return value.toDate();
    const seconds = value._seconds ?? value.seconds;
    if (seconds !== undefined) return new Date(seconds * 1000);
    return null;
  }
  if (typeof value === 'number') return new Date(value);
  const s = String(value);
  // 'YYYY-MM-DD' sin hora: construir en local para no correr un día por la zona horaria
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** DD/MM/AAAA */
export const formatDate = (value) => {
  const d = toDate(value);
  if (!d) return value ? String(value) : '—';
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
};

/** DD/MM/AAAA HH:mm (24 h) */
export const formatDateTime = (value) => {
  const d = toDate(value);
  if (!d) return value ? String(value) : '—';
  return `${formatDate(d)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/** "DD/MM/AAAA → DD/MM/AAAA"; sin fin: "DD/MM/AAAA → indefinido" (o el texto que se pase) */
export const formatDateRange = (start, end, openEndedLabel = '—') => {
  if (!start && !end) return '—';
  return `${formatDate(start)} → ${end ? formatDate(end) : openEndedLabel}`;
};

export default formatDate;
